import React from 'react'
import { connect } from 'react-redux'
import { SessionAwareComponent } from './SessionAwareComponent'
import ImmutablePropTypes from 'react-immutable-proptypes'
import PropTypes from 'prop-types'
import Page from '../../../frontend/app/components/Page'
import styles from '../../../frontend/account/containers/css/Login.scss'
import { FormattedMessage } from 'react-intl'
import Button from '../../../ui/Button'
import { push } from 'react-router-redux'
import { activateTenant } from '../../../frontend/app/session'

export class ActiveTenantRequired extends SessionAwareComponent {
    static propTypes = {
        children: PropTypes.node,
        session: ImmutablePropTypes.map.isRequired,
    }

    constructor(props) {
        super(props);
        this.state = { showTenantConfirmation: false };
    }

    componentDidMount() {
        const { tenant } = this.props;
        if (!tenant || !tenant.get('code_part')) {
            this.props.dispatch(push('/select'));
            return;
        }
        this.onSessionChange(null, this.props.session);
    }

    onSessionChange(prevSession, session) {
        const { tenant } = this.props;

        const authenticated = session && session.get('authenticated') && tenant && tenant.get('code_part');
        if (!authenticated) return;

        const user = session.get('user');
        if (!user) return;

        const tenants = user.get('tenants');
        if (!tenants) return;

        const tenantActive = tenants.contains(tenant.get('code_part'));
        this.setState({ showTenantConfirmation: !tenantActive });
    }

    handleSubmit() {
        this.props.dispatch(activateTenant());
    }

    handleCancel() {
        this.props.dispatch(push('/select'));
    }

    render() {
        const { showTenantConfirmation } = this.state;
        const { tenant, children } = this.props;

        if (!showTenantConfirmation) {
            return (<div>{children}</div>);
        }

        return (
            <Page.Body>
                <div className={styles.wrapper}>
                    <h2>
                        <FormattedMessage id='frontend.activate_tenant.headline' values={{ tenant: tenant.get('name') }} />
                    </h2>

                    <p><FormattedMessage id='frontend.activate_tenant.info' values={{ tenant: tenant.get('name') }} /></p>

                    <p>
                        <Button emphasis='primary' type='submit' block onClick={this.handleSubmit.bind(this)}>
                            <FormattedMessage id='frontend.activate_tenant.button.continue' />
                        </Button>
                    </p>

                    <p>
                        <Button emphasis='secondary' type='submit' block onClick={this.handleCancel.bind(this)}>
                            <FormattedMessage id='frontend.activate_tenant.button.cancel' />
                        </Button>
                    </p>
                </div>
            </Page.Body>
        );
    }
}

export default connect((state) => ({
    tenant: state.tenant,
}))(ActiveTenantRequired);
